<!-- Mobile Calculator View (hidden on desktop) -->
<app-mobile-calc-view
  class="d-md-none"
  [mobileView]="mobileView"
  [activeProductId]="mobileSelectedProductId"
  [rawMaterials]="rawMaterials"
  [directLabor]="directLabor"
  [indirectLabor]="indirectLabor"
  [fixedOverheads]="fixedOverheads"
  [variableOverheads]="variableOverheads"
  [employees]="rawMaterialsComponent?.employees || []"
  [fixedOverheadNames]="rawMaterialsComponent?.fixedOverheadNames || []"
  [variableOverheadItems]="rawMaterialsComponent?.itemsForVariableOverheadDropdown || []"
  [materialNames]="rawMaterialsComponent?.materialDropdownOptions || []"
  [accountType]="accountType"
  [uomList]="rawMaterialsComponent?.getAllUOMs() || []"
  [combinedCostItems]="combinedCostItems"
  [totalCost]="totalCost"
  [sellingPrice]="sellingPrice"
  [aiSuggestedPrice]="aiSuggestedPrice"
  [totalCostWithProfit]="totalCostWithProfit"
  [profitMargin]="profitMargin"
  [profitMarginPercentage]="profitMarginPercentage"
  [isLoading]="isLoading"
  [fullName]="fullName"
  [tenantName]="tenantName"
  [products]="rawMaterialsComponent?.products || []"
  [selectedProductName]="productName"
  [productName]="productName"
  [allProductCosts]="allProductCosts"
  [tenantProfile]="tenantProfile"
  [competitors]="competitors"
  [markupPercent]="markupPercent"
  [calculatorSellingPrice]="calculatorSellingPrice"
  [markupPrice]="getMarkupPrice()"
  [suggestedSellingPriceRaw]="suggestedSellingPrice"
  [productSellingPrice]="mobileProductSellingPrice"
  [targetTotalCost]="rawMaterialsComponent?.targetTotalCost ?? null"
  [mobileBusy]="mobileBusy"
  [mobileBusyLabel]="mobileBusyLabel"
  [fohBatchChangePending]="rawMaterialsComponent?.fohBatchChangePending || false"
  (productChange)="onMobileProductChange($event)"
  (marginChange)="onMobileMarginChange($event)"
  (saveAll)="onMobileSaveAll()"
  (costItemUpsert)="onMobileCostItemUpsert($event)"
  (costItemDelete)="onMobileCostItemDelete($event)"
  (sellingPriceChange)="onMobileSellingPriceChange($event)"
  (addProduct)="onMobileAddProduct()"
  (targetCostChange)="onMobileTargetCostChange($event)"
  (fohSaveAll)="onMobileFOHSaveAll()"
></app-mobile-calc-view>

<!-- Desktop Calculator View (hidden on mobile) -->
<div class="container-fluid d-none d-md-block">
  <div class="welcome-section mb-4 fade-in">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Cost Calculator</h2>
        <h4 class="welcome-text">
          Calculate your Product's Cost and get AI Insights
        </h4>
      </div>
      <div class="text-end">
        <small class="text-muted d-block">Current User:</small>
        <h6 class="mb-0">{{ fullName }}</h6>
        <small class="text-muted d-block">{{ tenantName }}</small>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in">
    <!-- Total Stock Items Card -->
    <!-- <div class="metric-card main" [ngClass]="{'positive': stockItemsTrend > 0, 'negative': stockItemsTrend < 0}"> -->



    <div class="metric-card main">
      <div class="card-content">
        <div class="icon-container warning">
         <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="7"
              height="7"
              rx="1"
              transform="matrix(1 0 0 -1 3 21)"
              stroke="#007A8F"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <rect
              width="7"
              height="7"
              rx="1"
              transform="matrix(1 0 0 -1 14 21)"
              stroke="#007A8F"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <rect
              width="7"
              height="7"
              rx="1"
              transform="matrix(1 0 0 -1 3 10)"
              stroke="#007A8F"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <rect
              width="7"
              height="7"
              rx="1"
              transform="matrix(1 0 0 -1 14 10)"
              stroke="#007A8F"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="metric-info">
          <div
            class="d-flex flex-row flex-grow-1 justify-content-evenly"
            style="align-items: center"
          >
            <!-- AI Suggested Selling Price -->
            <div class="d-flex flex-column" style="padding-left: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
  
                <h6
                  class="text-uppercase mb-0"
                  style="
                    letter-spacing: 0.5px;
                    font-size: 0.85rem;
                    color: #007a8f;
                    opacity: 0.9;
                  "
                >
                  Total Cost
                </h6>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem">
                   {{ totalCost | currency : "ZAR" : "symbol" : "1.2-2" }}
              </span>
            </div>

            <!-- Divider -->
            <div
              class="vr mx-2 mt-3"
              style="height: 50px; opacity: 0.3; background-color: #007a8f"
            ></div>

            <!-- Selling Price by Calculator -->
            <div class="d-flex flex-column" style="padding-right: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
       
                <h6
                  class="text-uppercase mb-0"
                  style="
                    letter-spacing: 0.5px;
                    font-size: 0.85rem;
                    color: #007a8f;
                    opacity: 0.9;
                  "
                >
                   Selling Price
                </h6>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem">
  {{ getSelectedProductSellingPrice() | currency : "ZAR" : "symbol" : "1.2-2" }}
              </span>
            </div>
          </div>
          <!-- <div class="trend-indicator positive" *ngIf="lowStockTrend < 0">{{ lowStockTrend }} this month</div>
          <div class="trend-indicator negative" *ngIf="lowStockTrend > 0">+{{ lowStockTrend }} this month</div>
          <div class="trend-indicator neutral" *ngIf="lowStockTrend === 0">No change</div> -->
        </div>
      </div>
    </div>







    <!-- Low Stock Items Card -->
    <!-- <div class="metric-card warning" [ngClass]="{'positive': lowStockTrend < 0, 'negative': lowStockTrend > 0}"></div> -->
    <div class="metric-card warning">
      <div class="card-content">
        <div class="icon-container warning">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 16H12.01M12 8V12M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#6C7A3E"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="metric-info">
          <div
            class="d-flex flex-row flex-grow-1 justify-content-evenly"
            style="align-items: center"
          >
            <!-- AI Suggested Selling Price -->
            <div class="d-flex flex-column" style="padding-left: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <i
                  class="bi bi-robot"
                  style="font-size: 1.2rem; color: #007a8f"
                ></i>
                <h6
                  class="text-uppercase mb-0"
                  style="
                    letter-spacing: 0.5px;
                    font-size: 0.85rem;
                    color: #007a8f;
                    opacity: 0.9;
                  "
                >
                  AI Suggested
                </h6>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem">
                {{
                  suggestedSellingPrice | currency : "ZAR" : "symbol" : "1.2-2"
                }}
              </span>
            </div>

            <!-- Divider -->
            <div
              class="vr mx-2 mt-3"
              style="height: 50px; opacity: 0.3; background-color: #007a8f"
            ></div>

            <!-- Selling Price by Calculator -->
            <div class="d-flex flex-column" style="padding-right: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <i
                  class="bi bi-calculator"
                  style="font-size: 1.2rem; color: #007a8f"
                ></i>
                <h6
                  class="text-uppercase mb-0"
                  style="
                    letter-spacing: 0.5px;
                    font-size: 0.85rem;
                    color: #007a8f;
                    opacity: 0.9;
                  "
                >
                  Calc Selling Price
                </h6>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem">
                {{
                  (isVatVendor ? calculatorSellingPrice * 1.15 : calculatorSellingPrice) | currency : "ZAR" : "symbol" : "1.2-2"
                }}
              </span>
              <small *ngIf="isVatVendor" class="text-muted text-center d-block" style="font-size: 0.72rem;">Incl. VAT (15%)</small>
            </div>
          </div>
          <!-- <div class="trend-indicator positive" *ngIf="lowStockTrend < 0">{{ lowStockTrend }} this month</div>
          <div class="trend-indicator negative" *ngIf="lowStockTrend > 0">+{{ lowStockTrend }} this month</div>
          <div class="trend-indicator neutral" *ngIf="lowStockTrend === 0">No change</div> -->
        </div>
      </div>
    </div>

    <!-- Total Stock Value Card -->
    <div class="metric-card success">
      <div class="card-content">
        <div class="icon-container success">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 15V17M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#B0213C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10C14.5 11.3807 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3807 9.5 10Z"
              stroke="#B0213C"
              stroke-width="2"
            />
          </svg>
        </div>
        <div class="metric-info">
          <div class="d-flex flex-row flex-grow-1 justify-content-evenly">
            <!-- AI Suggested Selling Price -->
            <div class="d-flex flex-column" style="padding-left: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <i
                  class="bi bi-robot"
                  style="font-size: 1.2rem; color: #007a8f"
                ></i>
                <h6
                  class="text-uppercase mb-0"
                  style="
                    letter-spacing: 0.5px;
                    font-size: 0.85rem;
                    opacity: 0.9;
                    color: #007a8f;
                  "
                >
                  AI Suggested
                </h6>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem">
                {{
                  getAISuggestedSellingPrice()
                    | currency : "ZAR" : "symbol" : "1.2-2"
                }}
              </span>
            </div>

            <!-- Divider -->
            <div
              class="vr mx-2 mt-3"
              style="height: 50px; opacity: 0.3; background-color: #007a8f"
            ></div>

            <div class="d-flex flex-column" style="padding-right: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <i
                  class="bi bi-calculator"
                  style="font-size: 1.2rem; color: #007a8f"
                ></i>

                <h6
                  class="text-uppercase mb-0"
                  style="
                    letter-spacing: 0.5px;
                    font-size: 0.85rem;
                    color: #007a8f;
                    opacity: 0.8;
                  "
                >
                  Markup Price
                </h6>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem">
                {{ getMarkupPrice() | currency : "ZAR" : "symbol" : "1.2-2" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- DRAGGABLE DASHBOARD ROW -->
  <div>
    <app-raw-materials
      #rawMaterialsComponent
      (costDataChange)="onCostDataChange($event)"
      (markupPercentChange)="onmarkupPercentChange($event)"
      (productNameChange)="onProductNameChange($event)"
      (allProductCostsLoaded)="onAllProductCostsLoaded($event)"
      [aiSuggestedSellingPrice]="suggestedSellingPrice"
      [aiSuggestedMarkup]="AIcalculatedMarkupPrice"
      (aiSuggestionLoaded)="handleAiSuggestionLoaded($event)"
    >
    </app-raw-materials>
  </div>
  <div class="row my-3" style="padding: 0px">
    <div class="col-md-4">
      <app-donut-chart
        [selectedProductName]="productName"
        [allProductCosts]="allProductCosts"
      ></app-donut-chart>
    </div>
    <div class="col-md-4">
      <app-cost-breakdown
        [directMaterials]="directMaterials"
        [directLabor]="directLabor"
        [indirectLabor]="indirectLabor"
        [fixedOverheads]="fixedOverheads"
        [variableOverheads]="variableOverheads"
      ></app-cost-breakdown>
    </div>
    <div class="col-md-4">
      <app-aivor-insights
        [tenantProfile]="tenantProfile"
        [productName]="productName"
        [directMaterials]="directMaterials"
        [directLabor]="directLabor"
        [indirectLabor]="indirectLabor"
        [fixedOverheads]="fixedOverheads"
        [variableOverheads]="variableOverheads"
        [competitors]="competitors"
        (suggestedPriceChange)="suggestedSellingPrice = $event"
        (markupPriceChange)="AIcalculatedMarkupPrice = $event"
      ></app-aivor-insights>
    </div>
  </div>
  <!-- STATIC COST BREAKDOWN TABLE ROW -->
  <!-- UPDATED COST BREAKDOWN TABLE -->
  <div class="metric-card mb-3">
    <div
      class="d-flex justify-content-between align-items-center pb-3 mb-3 chart-header-border"
    >
      <div class="d-flex align-items-center">
        <div class="chart-icon-container me-3 insight-icon">
          <i class="bi bi-pie-chart"></i>
        </div>
        <h3 class="chart-title mb-0">Cost Summary Table</h3>
      </div>
    </div>

    <div class="card-body">
      <div class="table-wrapper" style="max-height: 400px; overflow-y: auto">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-header">
            <tr>
              <th class="fw-bold">Product</th>
              <th class="fw-bold text-end">Total Cost</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let entry of mapToKeys(allProductCosts)">
              <!-- Sticky product row when expanded -->
              <tr
                class="cursor-pointer"
                [ngClass]="{ 'sticky-row': expandedProducts[entry.key] }"
                (click)="toggleExpand(entry.key)"
              >
                <td class="fw-semibold bg-white">
                  <i
                    class="bi me-2"
                    [ngClass]="{
                      'bi-chevron-down': !expandedProducts[entry.key],
                      'bi-chevron-up': expandedProducts[entry.key]
                    }"
                  ></i>
                  {{ entry.key }}
                </td>
                <td class="text-end fw-bold bg-white">
                  R{{ getProductTotal(entry.value) | number : "1.2-2" }}
                </td>
              </tr>

              <!-- Expanded cost details -->
              <tr *ngIf="expandedProducts[entry.key]" class="fade-in">
                <td colspan="2" style="padding: 12px 0">
                  <div class="material-items-container">
                    <ng-container *ngFor="let cost of entry.value">
                      <div class="material-item">
                        <div class="material-icon">
                          <i class="bi bi-cash-coin"></i>
                        </div>
                        <span class="material-name"
                          >{{ cost.itemOrRole }} ({{ cost.category }})</span
                        >
                        <span class="badge quantity-badge"
                          >R{{ cost.unitCost | number : "1.2-2" }}</span
                        >
                      </div>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <!-- end card body -->
  </div>
</div>

<!-- Unsaved-changes confirm dialog (visible on both desktop and mobile/PWA) -->
<div
  *ngIf="rawMaterialsComponent?.showUnsavedDialog"
  style="position: fixed; inset: 0; z-index: 20000; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.5); padding: 16px;"
>
  <div
    style="background: #fff; border-radius: 12px; max-width: 420px; width: 100%; box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25); overflow: hidden;"
  >
    <div style="padding: 18px 20px 8px; text-align: center;">
      <h5 style="margin: 0; font-weight: 600;">Unsaved Changes</h5>
    </div>
    <div style="padding: 4px 22px 18px; color: #344054; font-size: 0.95rem;">
      <p style="margin: 0 0 10px;">
        You have unsaved changes in the following
        {{ rawMaterialsComponent.unsavedCategoriesList.length === 1 ? "tab" : "tabs" }}:
      </p>
      <ul style="margin: 0 0 4px; padding-left: 20px;">
        <li
          *ngFor="let cat of rawMaterialsComponent.unsavedCategoriesList"
          style="font-weight: 600;"
        >
          {{ cat }}
        </li>
      </ul>
    </div>
    <div
      style="display: flex; flex-direction: column; gap: 8px; padding: 8px 20px 20px;"
    >
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="rawMaterialsComponent.isSavingBeforeLeave"
        (click)="rawMaterialsComponent.onUnsavedSaveAndLeave()"
      >
        <span
          *ngIf="rawMaterialsComponent.isSavingBeforeLeave"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        {{ rawMaterialsComponent.isSavingBeforeLeave ? "Saving…" : "Save & Leave" }}
      </button>
      <button
        type="button"
        class="btn btn-outline-danger"
        [disabled]="rawMaterialsComponent.isSavingBeforeLeave"
        (click)="rawMaterialsComponent.onUnsavedLeaveAnyway()"
      >
        Leave without saving
      </button>
      <button
        type="button"
        class="btn btn-light"
        [disabled]="rawMaterialsComponent.isSavingBeforeLeave"
        (click)="rawMaterialsComponent.onUnsavedStay()"
      >
        Stay on page
      </button>
    </div>
  </div>
</div>
